<template>
  <ws-search-form :placeholder="$t('Наименование ЦПДЭ')" class="ws-de-center__search" />
</template>

<script>
export default {
  name: 'WsDeCenterSearch'
}
</script>
